import React, { useEffect } from 'react'
import '../../../css/Common-components/Modal/alert.css'

/**
 * 전역 알림창 컴포넌트
 * 기능 수정일
 * 250806 제갈민혁
 * 
 * @usage
 * alert({
 *    title: '알림 제목', // (선택) 없으면 기본값: '알림'
 *    content: '알림 내용입니다.', // (필수) 문자열 또는 JSX
 *    confirmButtonText: '닫기', // (선택) 기본값: '확인'
 *    showConfirmButton: false, // (선택) 기본값: true. false로 설정 시 기본 확인 버튼 숨김
 *    footerContent: <button type='button'>추가 버튼</button>, // (선택) 추가 버튼을 넣을 수 있음
 *    action: () => { console.log('추가 버튼 클릭됨'); } // (선택) 추가 버튼 클릭 시 실행될 함수
 * });
 *
 * @description
 * - 기본 버튼(`confirmButtonText`)은 알림창을 닫는 역할만 합니다.
 * - `footerContent`에 추가된 버튼은 `action`에 정의된 함수를 실행하고 알림창을 닫습니다.
 * - `action`이 없으면, 추가 버튼도 닫는 역할만 합니다.
 */

function Alert({ isOpen, title, content, footerContent, onClose, onAction, confirmButtonText = '확인', showConfirmButton = true }) {
    useEffect(() => {
        if (isOpen) {
            // 스크롤바 너비 계산
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
        }

        // 컴포넌트 언마운트 시 스크롤 복원
        return () => {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    // `footerContent`로 전달된 버튼에 자동으로 `onAction` 기능수행.
    const enhancedFooterContent = footerContent && React.isValidElement(footerContent)
        ? React.cloneElement(footerContent, { onClick: onAction })
        : footerContent;

    return (
        <div className="alert-overlay">
            <div className="alert">
                <div className="alert-body">
                    {title && <h2 className="alert-title">{title}</h2>}
                    {typeof content === 'string' ? <p className='alert-content'>{content}</p> : <div className='alert-content'>{content}</div>}
                </div>

                <div className="alert-footer">
                    {/* showConfirmButton이 true일 때만 기본 버튼을 렌더링합니다. */}
                    {showConfirmButton && (
                        <button type='button' className='btn close-btn' onClick={onClose}>{confirmButtonText}</button>
                    )}
                    {enhancedFooterContent}
                </div>
            </div>
        </div>
    );
}

export default Alert;